import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import t from '@/utils/Language/ResourceCard-translations';
import classes from './ResourceCardPanel.module.scss';

const HasEligibilityRequirements = ({ resource }) => {
  if (!resource?.properties || resource.properties['elig-available-everyone']) {
    return null;
  }

  return (
    <div className={classes.eligReqs}>
      <FontAwesomeIcon icon="fa-solid fa-clipboard-check" className={classes.eligIcon} />
      <span>{t('Has eligibility requirements')}</span>
    </div>
  );
};

export default HasEligibilityRequirements;
